import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { getArticleById, getMagzineAndDairy, updateArticle } from './_request';
import { useAuth } from '../context/AuthContext';

const EditPreviewArticle = () => {

  const navigate = useNavigate();
  const { authToken } = useAuth();
  const location = useLocation();  
  const { articleId } = location.state; 
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [readTime, setReadTime] = useState('');
  const [category, setCategory] = useState('');
  const [parentCategory, setParentCategory] = useState('');
  const [error, setError] = useState('');
  const [articleType, setArticleType] = useState('');
  const [magzine, setMagzine] = useState([]); 
  const [diary, setDiary] = useState([]); 
  const [year, setYear] = useState(''); 


  useEffect(() => {

  const magzineAndDiary = async () => {
    try {
      const response = await getMagzineAndDairy(authToken);
      if (response.Result) {
        setMagzine(response.Magazines);
        setDiary(response.Diaries);
      }
    } catch (error) {
      console.error('Error fetching magazines and diaries:', error);
    }
  };

 
    const fetchArticle = async () => {
      try {
        const article = await getArticleById(authToken, articleId);
        if(article.Result){
          const data = article.Article
        setTitle(data.title);
        setContent(data.content);
        setReadTime(data.read_min);
        setParentCategory(data.parentCategory || '');
        setCategory(data.category);
        setArticleType(data.article_type);
        setYear(data.year)
        }
      } catch (err) {
        setError('Failed to fetch article data');
      }
    };
    fetchArticle();
    magzineAndDiary()
  }, [articleId, authToken]);
  
  const handleTitleChange = (e) => setTitle(e.target.value);
  const handleContentChange = (value) => setContent(value);
  const handleReadTimeChange = (e) => setReadTime(e.target.value);
  const handleCategoryChange = (e) => setCategory(e.target.value);
  const handleArticleTypeChange = (e) => setArticleType(e.target.value);
  const handleYearChange = (e) => setYear(e.target.value);

  const handleSubmit = async () => {
    if (!title || !content || !readTime || !category || !articleType || !year) {
      setError('Please fill out all fields');
      return;
    }
    setError('');
    const data = { title, content, readTime, category, articleType, parentCategory, year };
    try {
      const response = await updateArticle(authToken, articleId, data);
      if (response.Result) {
        alert('Article updated successfully!');
        navigate('/tazakraatreview/reviewArticle', { state: { articleId } });
      } else {
        setError('Failed to update the article. Please try again.');
      }
    } catch (error) {
      setError('An error occurred. Please try again.');
      console.error('Error updating article:', error);
    }
  };
  const modules = {
    toolbar: [
      [{ header: 1 }, { header: 2 }, { header: 3 }, { header: 4 }, { font: [] }], // Custom headers
      [{ size: [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ color: [] }, { background: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: [] }],
      ['clean'],
    ],
  };
  
  const formats = [
    'header', 'font', 'size', 'bold', 'italic', 'underline',
    'color', 'background', 'list', 'bullet', 'align'
  ];
  return (
    <div className="sm:px-6 lg:px-8">
      <button
        onClick={() => navigate('/tazakraatreview/reviewArticle', { state: { articleId } })}
        className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-3"
      >
        Go Back
      </button>
      <div className="w-full h-fit bg-white p-6 rounded-lg shadow-lg">
        {/* Page Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-semibold">Edit Article</h2>
          <button
            className="py-2 px-6 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 transition"
            onClick={handleSubmit}
          >
            Update Article
          </button>
        </div>

        {/* Article Form */}
        <div>
          {error && (
            <div className="text-red-500 text-sm mb-4">{error}</div>
          )}
          {/* Title Input */}
          <div className="mb-6">
            <label htmlFor="title" className="block text-sm font-semibold mb-2">
              Title
            </label>
            <input
              type="text"
              id="title"
              value={title}
              onChange={handleTitleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm"
              placeholder="Enter article title"
            />
          </div>
          {/* Article Type Select */}
          <div className="mb-6">
            <label htmlFor="articleType" className="block text-sm font-semibold mb-2">
              Article Type
            </label>
            <select
              id="articleType"
              value={articleType}
              onChange={handleArticleTypeChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm"
            >
              <option value="">Select Article Type</option>
              <option value="Magazine">Magazine</option>
              <option value="Diary">Diary</option>
            </select>
          </div>
          {articleType === 'Diary' &&
            <div className="mb-6">
              <label htmlFor="articleType" className="block text-sm font-semibold mb-2">
                Parent Category
              </label>
              <select
                id="articleType"
                value={parentCategory}
                onChange={(e) => setParentCategory(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm"
              >
                <option value="">Select Article Type</option>
                <option value="محاسبہ">محاسبہ</option>
                <option value="یاد امام"> یاد امام </option>
              </select>
            </div>}
            {articleType && (
            <div className="mb-6">
              <label htmlFor="year" className="block text-sm font-semibold mb-2">
                Year
              </label>
              <select
                id="year"
                value={year}
                onChange={handleYearChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm"
              >
                <option value="">Select Year</option>
                {articleType === "Magazine"
                  ? magzine.map((mag) => (
                      <option key={mag.id} value={mag.id}>
                        {mag.year}
                      </option>
                    ))
                  : diary.map((diary) => (
                      <option key={diary.id} value={diary.id}>
                        {diary.year}
                      </option>
                    ))}
              </select>
            </div>
          )}
          {/* Category Input */}
          <div className="mb-6">
            <label htmlFor="category" className="block text-sm font-semibold mb-2">
              Category
            </label>
            <select
              id="category"
              value={category}
              onChange={handleCategoryChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm"
            >
              <option value="">Select Category</option>
              {articleType === "Diary" ? (
                parentCategory === "محاسبہ" ? (
                  <>
                    <option value="نماز شب">نماز شب</option>
                    <option value="نماز صبح و سحر خیزی">نماز صبح و سحر خیزی</option>
                    <option value="قرآن و دعا">قرآن و دعا</option>
                    <option value="ورزش">ورزش</option>
                    <option value="نظم ٹائم ٹیبل">نظم ٹائم ٹیبل</option>
                    <option value="غور و فکر">غور و فکر</option>
                    <option value="مطالعہ و حصول علم">مطالعہ و حصول علم</option>
                    <option value="تعلیم اہل خانہ و مومنین">تعلیم اہل خانہ و مومنین</option>
                    <option value="صدقہ">صدقہ</option>
                    <option value="معرفت امام زمانہ علیہ السلام">معرفت امام زمانہ علیہ السلام</option>
                    <option value="تعارف امام میں سعی">تعارف امام میں سعی</option>
                    <option value="احسان به والدین صله رحم">احسان به والدین صله رحم</option>
                    <option value="امداد مؤمنین">امداد مؤمنین</option>
                    <option value="ایفائے عہد">ایفائے عہد</option>
                    <option value="امر معروف و نهی از منکر">امر معروف و نهی از منکر</option>
                    <option value="مستحب روزه">مستحب روزه</option>
                    <option value="نامحرم پر نگاہ سے اجتناب">نامحرم پر نگاہ سے اجتناب</option>
                    <option value="غیبت و تہمت سے دوری">غیبت و تہمت سے دوری</option>
                    <option value="جھوٹ ونفاق سے پر ہیز">جھوٹ ونفاق سے پر ہیز</option>
                    <option value="بد اخلاقی پخش گوئی سے اجتناب">بد اخلاقی پخش گوئی سے اجتناب</option>
                    <option value="لہو ولعب سے پر ہیز غضب و غصہ سے دوری">
                      لہو ولعب سے پر ہیز غضب و غصہ سے دوری
                    </option>
                    <option value="ریا کاری سے اجتناب">ریا کاری سے اجتناب</option>
                    <option value="حد سے پر ہیز">حد سے پر ہیز</option>
                  </>
                ) : (
                  <option value="یاد امام ">یاد امام</option>
                )
              ) : (
                <>
                  <option value="محرم"> محرم</option>
                  <option value="ایام فاطمیہ">ایام فاطمیہ</option>
                </>
              )}
            </select>
          </div>

          {/* Read Time Input */}
          <div className="mb-6">
            <label htmlFor="readTime" className="block text-sm font-semibold mb-2">
              Read Time (minutes)
            </label>
            <input
              type="number"
              id="readTime"
              value={readTime}
              onChange={handleReadTimeChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md text-sm"
              placeholder="Enter article read time"
            />
          </div>

          {/* Quill Editor */}
          <div className="border-none">
            <label htmlFor="content" className="block text-sm font-semibold mb-2">
              Content
            </label>
            <div className='mb-14'>
              <ReactQuill
                value={content}
                onChange={handleContentChange}
                modules={modules}
                formats={formats}
                className="h-52"
                placeholder="Write your article content here"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPreviewArticle;